import { Box, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  container: {
    margin: theme.spacing(3, 0, 2, 3),
  },
}));

function SkeletonInitNotes() {
  const classes = useStyles();
  return (
    <Grid container>
      <Grid item xs={4}>
        <Skeleton variant="rectangular" width={200} height={50} />
        <Box>
          <Skeleton variant="rectangular" width={300} height={20} className={classes.container} />
          <Skeleton variant="rectangular" width={300} height={20} className={classes.container} />
          <Skeleton variant="rectangular" width={300} height={20} className={classes.container} />
        </Box>
      </Grid>
    </Grid>
  );
}

export default SkeletonInitNotes;
